import { render, staticRenderFns } from "./MetadataManager.vue?vue&type=template&id=89b81604&"
import script from "./MetadataManager.vue?vue&type=script&lang=ts&"
export * from "./MetadataManager.vue?vue&type=script&lang=ts&"
import style0 from "./MetadataManager.vue?vue&type=style&index=0&id=89b81604&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports